module.exports = __webpack_public_path__ + "static/img/cgal16.bf775e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/cgal16.png
// module id = CW7L
// module chunks = 1